import type { ListboxOptionItem } from '@shared/ui/listbox';

/** Figma `Select`(Components, 36:1017)의 축 */
export const SELECT_SIZES = ['md', 'sm'] as const;
export type SelectSize = (typeof SELECT_SIZES)[number];

export const SELECT_STATUSES = ['default', 'init', 'empty', 'loading'] as const;
export type SelectStatus = (typeof SELECT_STATUSES)[number];

/** 선택지 하나. 도메인 선택 상자(FundSelect 등)도 이 모양으로 넘긴다 */
export type SelectOption = ListboxOptionItem;

/** 트리거 크기: md 높이 40 · 왼쪽 16 · 오른쪽 12 · 글자 body / sm 높이 32 · 왼쪽 12 · 오른쪽 8 · 글자 body-sm */
export const SELECT_SIZE_CLASS: Record<SelectSize, string> = {
  md: 'h-(--size-control-md) pr-3 pl-4 typo-body',
  sm: 'h-(--size-control-sm) pr-2 pl-3 typo-body-sm',
};

/** 트리거 테두리 · 면. 모서리 · 테두리는 TextInput 과 같다(atoms.md "하나로 맞춘 값") */
export const SELECT_STATE_CLASS = {
  default: 'cursor-pointer border border-border-input bg-bg-surface',
  /** open=true — 2px focus 테두리 */
  open: 'cursor-pointer border-2 border-border-input-focus bg-bg-surface',
  /** state=error */
  invalid: 'cursor-pointer border-2 border-border-danger bg-bg-surface',
  /** state=disabled */
  disabled: 'cursor-not-allowed border border-border-default bg-bg-disabled',
} as const;

/** 값 글자 색: 값이 있으면 기본, 없으면 placeholder, 비활성은 disabled */
export const SELECT_VALUE_CLASS = {
  filled: 'text-fg-default',
  empty: 'text-fg-placeholder',
  disabled: 'text-fg-disabled',
} as const;

/** 스켈레톤(status=init) 높이 */
export const SELECT_SKELETON_SIZE_CLASS: Record<SelectSize, string> = {
  md: 'h-(--size-control-md)',
  sm: 'h-(--size-control-sm)',
};
